module.exports = __webpack_public_path__ + "static/aon-overview--mobile-020a79a1812b18e4d654d4df343f5988.png";